// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splash-screen {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: #fff;
}

.logo-splash {
    width: 30%;
    display: flex;
    margin-top: -15%;
}

@media screen and (min-width: 1025px) {
    .logo-splash {
        width: 15%; /* Sesuaikan lebar sesuai kebutuhan */
        max-width: 200px; /* Batasi lebar maksimum untuk responsivitas */
        margin-top: -8%; /* Sesuaikan margin sesuai kebutuhan */
    }
}

.text-splash {
    position: fixed;
    bottom: 10%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    color: #fff;
}

.text-from {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    color: black;
    font-size: 13px;
    font-family: 'Poppins', sans-serif;
    margin-bottom: 4px;
}

.wrap-logo {
    width: 32% !important; /* Sesuaikan lebar sesuai kebutuhan */
    max-width: 300px; /* Batasi lebar maksimum untuk responsivitas */
    height: auto; /* Agar tingginya disesuaikan otomatis */
    position: absolute;
    bottom: 1% !important; /* Letakkan logo di paling bawah layar */
    margin-bottom: 0;
    margin-left: 1%;
}

/* Gaya untuk tampilan desktop */
@media screen and (min-width: 1025px) {
    .wrap-logo {
        width: 140px !important; /* Sesuaikan lebar sesuai kebutuhan */
        max-width: 300px; /* Batasi lebar maksimum untuk responsivitas */
        height: auto; /* Agar tingginya disesuaikan otomatis */
        position: absolute;
        bottom: 1% !important; /* Letakkan logo di paling bawah layar */
        margin-bottom: 0;
        margin-left: 0;
    }
}

@media screen and (max-width: 767px) {
    .wrap-logo {
        width: 100%; /* Adjust width for mobile devices */
        max-width: none; /* Remove maximum width restriction */
        position: absolute;
        margin: 1% auto; /* Center the logo on mobile */
        bottom: initial; /* Remove the absolute positioning */
        margin-bottom: 0;
    }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
    .wrap-logo {
        width: 170px !important; /* Adjust width for iPad */
        max-width: none; /* Remove maximum width restriction */
        position: absolute;
        margin: 1% auto; /* Center the logo on iPad */
        bottom: initial; /* Remove the absolute positioning */
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/SplashScreen/SplashScreen.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU,EAAE,qCAAqC;QACjD,gBAAgB,EAAE,8CAA8C;QAChE,eAAe,EAAE,sCAAsC;IAC3D;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,qBAAqB,EAAE,qCAAqC;IAC5D,gBAAgB,EAAE,8CAA8C;IAChE,YAAY,EAAE,wCAAwC;IACtD,kBAAkB;IAClB,qBAAqB,EAAE,wCAAwC;IAC/D,gBAAgB;IAChB,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI;QACI,uBAAuB,EAAE,qCAAqC;QAC9D,gBAAgB,EAAE,8CAA8C;QAChE,YAAY,EAAE,wCAAwC;QACtD,kBAAkB;QAClB,qBAAqB,EAAE,wCAAwC;QAC/D,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,WAAW,EAAE,oCAAoC;QACjD,eAAe,EAAE,qCAAqC;QACtD,kBAAkB;QAClB,eAAe,EAAE,8BAA8B;QAC/C,eAAe,EAAE,oCAAoC;QACrD,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,uBAAuB,EAAE,0BAA0B;QACnD,eAAe,EAAE,qCAAqC;QACtD,kBAAkB;QAClB,eAAe,EAAE,4BAA4B;QAC7C,eAAe,EAAE,oCAAoC;IACzD;AACJ","sourcesContent":[".splash-screen {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n    background-color: #fff;\n}\n\n.logo-splash {\n    width: 30%;\n    display: flex;\n    margin-top: -15%;\n}\n\n@media screen and (min-width: 1025px) {\n    .logo-splash {\n        width: 15%; /* Sesuaikan lebar sesuai kebutuhan */\n        max-width: 200px; /* Batasi lebar maksimum untuk responsivitas */\n        margin-top: -8%; /* Sesuaikan margin sesuai kebutuhan */\n    }\n}\n\n.text-splash {\n    position: fixed;\n    bottom: 10%;\n    left: 50%;\n    transform: translateX(-50%);\n    text-align: center;\n    color: #fff;\n}\n\n.text-from {\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    color: black;\n    font-size: 13px;\n    font-family: 'Poppins', sans-serif;\n    margin-bottom: 4px;\n}\n\n.wrap-logo {\n    width: 32% !important; /* Sesuaikan lebar sesuai kebutuhan */\n    max-width: 300px; /* Batasi lebar maksimum untuk responsivitas */\n    height: auto; /* Agar tingginya disesuaikan otomatis */\n    position: absolute;\n    bottom: 1% !important; /* Letakkan logo di paling bawah layar */\n    margin-bottom: 0;\n    margin-left: 1%;\n}\n\n/* Gaya untuk tampilan desktop */\n@media screen and (min-width: 1025px) {\n    .wrap-logo {\n        width: 140px !important; /* Sesuaikan lebar sesuai kebutuhan */\n        max-width: 300px; /* Batasi lebar maksimum untuk responsivitas */\n        height: auto; /* Agar tingginya disesuaikan otomatis */\n        position: absolute;\n        bottom: 1% !important; /* Letakkan logo di paling bawah layar */\n        margin-bottom: 0;\n        margin-left: 0;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .wrap-logo {\n        width: 100%; /* Adjust width for mobile devices */\n        max-width: none; /* Remove maximum width restriction */\n        position: absolute;\n        margin: 1% auto; /* Center the logo on mobile */\n        bottom: initial; /* Remove the absolute positioning */\n        margin-bottom: 0;\n    }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n    .wrap-logo {\n        width: 170px !important; /* Adjust width for iPad */\n        max-width: none; /* Remove maximum width restriction */\n        position: absolute;\n        margin: 1% auto; /* Center the logo on iPad */\n        bottom: initial; /* Remove the absolute positioning */\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
